<template>
  <dashboard-template />
</template>

<script>
import DashboardTemplate from "../components/templates/DashboardTemplate.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    DashboardTemplate,
  },
});
</script>
